export var serverAndDesktopReleases = [
  {
    startDate: new Date("2014-04-01T00:00:00"),
    endDate: new Date("2019-04-02T00:00:00"),
    taskName: "14.04 LTS (Trusty Tahr)",
    status: "HARDWARE_AND_MAINTENANCE_UPDATES",
  },
  {
    startDate: new Date("2019-04-02T00:00:00"),
    endDate: new Date("2024-05-02T00:00:00"),
    taskName: "14.04 LTS (Trusty Tahr)",
    status: "ESM",
  },
  {
    startDate: new Date("2024-05-02T00:00:00"),
    endDate: new Date("2029-05-02T00:00:00"),
    taskName: "14.04 LTS (Trusty Tahr)",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2016-04-01T00:00:00"),
    endDate: new Date("2021-04-02T00:00:00"),
    taskName: "16.04 LTS (Xenial Xerus)",
    status: "HARDWARE_AND_MAINTENANCE_UPDATES",
  },
  {
    startDate: new Date("2021-04-02T00:00:00"),
    endDate: new Date("2026-05-02T00:00:00"),
    taskName: "16.04 LTS (Xenial Xerus)",
    status: "ESM",
  },
  {
    startDate: new Date("2016-04-01T00:00:00"),
    endDate: new Date("2026-05-02T00:00:00"),
    taskName: "16.04 LTS (Xenial Xerus)",
    status: "MAIN_UNIVERSE",
  },
  {
    startDate: new Date("2026-05-02T00:00:00"),
    endDate: new Date("2031-05-02T00:00:00"),
    taskName: "16.04 LTS (Xenial Xerus)",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2018-04-01T00:00:00"),
    endDate: new Date("2023-05-02T00:00:00"),
    taskName: "18.04 LTS (Bionic Beaver)",
    status: "HARDWARE_AND_MAINTENANCE_UPDATES",
  },
  {
    startDate: new Date("2023-05-02T00:00:00"),
    endDate: new Date("2028-05-01T00:00:00"),
    taskName: "18.04 LTS (Bionic Beaver)",
    status: "ESM",
  },
  {
    startDate: new Date("2018-04-01T00:00:00"),
    endDate: new Date("2028-05-01T00:00:00"),
    taskName: "18.04 LTS (Bionic Beaver)",
    status: "MAIN_UNIVERSE",
  },
  {
    startDate: new Date("2028-05-01T00:00:00"),
    endDate: new Date("2033-05-01T00:00:00"),
    taskName: "18.04 LTS (Bionic Beaver)",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2020-04-01T00:00:00"),
    endDate: new Date("2025-05-02T00:00:00"),
    taskName: "20.04 LTS (Focal Fossa)",
    status: "HARDWARE_AND_MAINTENANCE_UPDATES",
  },
  {
    startDate: new Date("2025-05-02T00:00:00"),
    endDate: new Date("2030-05-02T00:00:00"),
    taskName: "20.04 LTS (Focal Fossa)",
    status: "ESM",
  },
  {
    startDate: new Date("2020-04-01T00:00:00"),
    endDate: new Date("2030-05-02T00:00:00"),
    taskName: "20.04 LTS (Focal Fossa)",
    status: "MAIN_UNIVERSE",
  },
  {
    startDate: new Date("2030-05-02T00:00:00"),
    endDate: new Date("2035-05-02T00:00:00"),
    taskName: "20.04 LTS (Focal Fossa)",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2022-04-01T00:00:00"),
    endDate: new Date("2027-05-01T00:00:00"),
    taskName: "22.04 LTS (Jammy Jellyfish)",
    status: "HARDWARE_AND_MAINTENANCE_UPDATES",
  },
  {
    startDate: new Date("2022-04-01T00:00:00"),
    endDate: new Date("2032-05-01T00:00:00"),
    taskName: "22.04 LTS (Jammy Jellyfish)",
    status: "MAIN_UNIVERSE",
  },
  {
    startDate: new Date("2027-05-01T00:00:00"),
    endDate: new Date("2032-05-01T00:00:00"),
    taskName: "22.04 LTS (Jammy Jellyfish)",
    status: "ESM",
  },
  {
    startDate: new Date("2032-05-01T00:00:00"),
    endDate: new Date("2037-05-01T00:00:00"),
    taskName: "22.04 LTS (Jammy Jellyfish)",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2024-04-25T00:00:00"),
    endDate: new Date("2034-05-25T00:00:00"),
    taskName: "24.04 LTS (Noble Numbat)",
    status: "MAIN_UNIVERSE",
  },
  {
    startDate: new Date("2024-04-25T00:00:00"),
    endDate: new Date("2029-05-25T00:00:00"),
    taskName: "24.04 LTS (Noble Numbat)",
    status: "HARDWARE_AND_MAINTENANCE_UPDATES",
  },
  {
    startDate: new Date("2029-05-25T00:00:00"),
    endDate: new Date("2034-05-25T00:00:00"),
    taskName: "24.04 LTS (Noble Numbat)",
    status: "ESM",
  },
  {
    startDate: new Date("2034-05-25T00:00:00"),
    endDate: new Date("2039-05-25T00:00:00"),
    taskName: "24.04 LTS (Noble Numbat)",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2026-04-23T00:00:00"),
    endDate: new Date("2036-05-23T00:00:00"),
    taskName: "26.04 LTS (Resolute Raccoon)",
    status: "MAIN_UNIVERSE",
  },
  {
    startDate: new Date("2026-04-23T00:00:00"),
    endDate: new Date("2031-05-23T00:00:00"),
    taskName: "26.04 LTS (Resolute Raccoon)",
    status: "HARDWARE_AND_MAINTENANCE_UPDATES",
  },
  {
    startDate: new Date("2031-05-23T00:00:00"),
    endDate: new Date("2036-05-23T00:00:00"),
    taskName: "26.04 LTS (Resolute Raccoon)",
    status: "ESM",
  },
  {
    startDate: new Date("2036-05-23T00:00:00"),
    endDate: new Date("2041-05-23T00:00:00"),
    taskName: "26.04 LTS (Resolute Raccoon)",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2026-10-01T00:00:00"),
    endDate: new Date("2027-07-07T00:00:00"),
    taskName: "26.10 (Stonking Stingray)",
    status: "INTERIM_RELEASE",
  },
];

export var kernelReleases = [
  {
    startDate: new Date("2026-10-15T00:00:00"),
    endDate: new Date("2027-07-01T00:00:00"),
    taskName: "26.10",
    taskVersion: "7.3 kernel",
    status: "INTERIM_RELEASE",
  },
  {
    startDate: new Date("2026-07-15T00:00:00"),
    endDate: new Date("2029-05-01T00:00:00"),
    taskName: "24.04.5 LTS (HWE)",
    taskVersion: "7.0 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2029-05-01T00:00:00"),
    endDate: new Date("2034-05-01T00:00:00"),
    taskName: "24.04.5 LTS (HWE)",
    taskVersion: "7.0 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2034-05-01T00:00:00"),
    endDate: new Date("2039-05-01T00:00:00"),
    taskName: "24.04.5 LTS (HWE)",
    taskVersion: "7.0 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2026-04-01T00:00:00"),
    endDate: new Date("2031-05-01T00:00:00"),
    taskName: "26.04.0 LTS",
    taskVersion: "7.0 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2031-05-01T00:00:00"),
    endDate: new Date("2036-05-01T00:00:00"),
    taskName: "26.04.0 LTS",
    taskVersion: "7.0 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2036-05-01T00:00:00"),
    endDate: new Date("2041-05-01T00:00:00"),
    taskName: "26.04.0 LTS",
    taskVersion: "7.0 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2026-01-15T00:00:00"),
    endDate: new Date("2026-07-15T00:00:00"),
    taskName: "24.04.4 LTS (HWE)",
    taskVersion: "6.17 kernel",
    status: "INTERIM_RELEASE",
  },
  {
    startDate: new Date("2025-10-01T00:00:00"),
    endDate: new Date("2026-07-01T00:00:00"),
    taskName: "25.10",
    taskVersion: "6.17 kernel",
    status: "INTERIM_RELEASE",
  },
  {
    startDate: new Date("2024-07-15T00:00:00"),
    endDate: new Date("2027-05-01T00:00:00"),
    taskName: "22.04.5 LTS (HWE)",
    taskVersion: "6.8 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2027-05-01T00:00:00"),
    endDate: new Date("2032-05-01T00:00:00"),
    taskName: "22.04.5 LTS (HWE)",
    taskVersion: "6.8 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2032-05-01T00:00:00"),
    endDate: new Date("2037-05-01T00:00:00"),
    taskName: "22.04.5 LTS (HWE)",
    taskVersion: "6.8 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2024-07-15T00:00:00"),
    endDate: new Date("2029-05-01T00:00:00"),
    taskName: "24.04.1 LTS",
    taskVersion: "6.8 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2029-05-01T00:00:00"),
    endDate: new Date("2034-05-01T00:00:00"),
    taskName: "24.04.1 LTS",
    taskVersion: "6.8 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2034-05-01T00:00:00"),
    endDate: new Date("2039-05-01T00:00:00"),
    taskName: "24.04.1 LTS",
    taskVersion: "6.8 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2024-04-01T00:00:00"),
    endDate: new Date("2029-05-01T00:00:00"),
    taskName: "24.04.0 LTS",
    taskVersion: "6.8 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2029-05-01T00:00:00"),
    endDate: new Date("2034-05-01T00:00:00"),
    taskName: "24.04.0 LTS",
    taskVersion: "6.8 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2034-05-01T00:00:00"),
    endDate: new Date("2039-05-01T00:00:00"),
    taskName: "24.04.0 LTS",
    taskVersion: "6.8 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2022-07-15T00:00:00"),
    endDate: new Date("2025-05-23T00:00:00"),
    taskName: "20.04.5 LTS (HWE)",
    taskVersion: "5.15 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2025-05-23T00:00:00"),
    endDate: new Date("2030-05-23T00:00:00"),
    taskName: "20.04.5 LTS (HWE)",
    taskVersion: "5.15 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2030-05-23T00:00:00"),
    endDate: new Date("2035-05-01T00:00:00"),
    taskName: "20.04.5 LTS (HWE)",
    taskVersion: "5.15 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2022-07-15T00:00:00"),
    endDate: new Date("2027-05-01T00:00:00"),
    taskName: "22.04.1 LTS",
    taskVersion: "5.15 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2027-05-01T00:00:00"),
    endDate: new Date("2032-05-01T00:00:00"),
    taskName: "22.04.1 LTS",
    taskVersion: "5.15 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2032-05-01T00:00:00"),
    endDate: new Date("2037-05-01T00:00:00"),
    taskName: "22.04.1 LTS",
    taskVersion: "5.15 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2022-04-01T00:00:00"),
    endDate: new Date("2027-05-01T00:00:00"),
    taskName: "22.04.0 LTS",
    taskVersion: "5.15 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2027-05-01T00:00:00"),
    endDate: new Date("2032-05-01T00:00:00"),
    taskName: "22.04.0 LTS",
    taskVersion: "5.15 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2032-05-01T00:00:00"),
    endDate: new Date("2037-05-01T00:00:00"),
    taskName: "22.04.0 LTS",
    taskVersion: "5.15 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2020-07-15T00:00:00"),
    endDate: new Date("2023-05-26T00:00:00"),
    taskName: "18.04.5 LTS (HWE)",
    taskVersion: "5.4 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2023-05-26T00:00:00"),
    endDate: new Date("2028-05-26T00:00:00"),
    taskName: "18.04.5 LTS (HWE)",
    taskVersion: "5.4 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2028-05-26T00:00:00"),
    endDate: new Date("2033-05-01T00:00:00"),
    taskName: "18.04.5 LTS (HWE)",
    taskVersion: "5.4 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2020-07-15T00:00:00"),
    endDate: new Date("2025-05-23T00:00:00"),
    taskName: "20.04.1 LTS",
    taskVersion: "5.4 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2025-05-23T00:00:00"),
    endDate: new Date("2030-05-23T00:00:00"),
    taskName: "20.04.1 LTS",
    taskVersion: "5.4 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2030-05-23T00:00:00"),
    endDate: new Date("2035-05-01T00:00:00"),
    taskName: "20.04.1 LTS",
    taskVersion: "5.4 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2020-04-23T00:00:00"),
    endDate: new Date("2025-05-23T00:00:00"),
    taskName: "20.04.0 LTS",
    taskVersion: "5.4 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2025-05-23T00:00:00"),
    endDate: new Date("2030-05-23T00:00:00"),
    taskName: "20.04.0 LTS",
    taskVersion: "5.4 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2030-05-23T00:00:00"),
    endDate: new Date("2035-05-01T00:00:00"),
    taskName: "20.04.0 LTS",
    taskVersion: "5.4 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2018-07-15T00:00:00"),
    endDate: new Date("2021-04-21T00:00:00"),
    taskName: "16.04.5 LTS (HWE)",
    taskVersion: "4.15 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2021-04-21T00:00:00"),
    endDate: new Date("2026-05-21T00:00:00"),
    taskName: "16.04.5 LTS (HWE)",
    taskVersion: "4.15 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2026-05-21T00:00:00"),
    endDate: new Date("2031-05-01T00:00:00"),
    taskName: "16.04.5 LTS (HWE)",
    taskVersion: "4.15 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2018-07-26T00:00:00"),
    endDate: new Date("2023-05-26T00:00:00"),
    taskName: "18.04.1 LTS",
    taskVersion: "4.15 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2023-05-26T00:00:00"),
    endDate: new Date("2028-05-24T00:00:00"),
    taskName: "18.04.1 LTS",
    taskVersion: "4.15 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2028-05-24T00:00:00"),
    endDate: new Date("2033-05-01T00:00:00"),
    taskName: "18.04.1 LTS",
    taskVersion: "4.15 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2018-04-26T00:00:00"),
    endDate: new Date("2023-05-26T00:00:00"),
    taskName: "18.04.0 LTS",
    taskVersion: "4.15 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2023-05-26T00:00:00"),
    endDate: new Date("2028-05-26T00:00:00"),
    taskName: "18.04.0 LTS",
    taskVersion: "4.15 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2028-05-26T00:00:00"),
    endDate: new Date("2033-05-01T00:00:00"),
    taskName: "18.04.0 LTS",
    taskVersion: "4.15 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2016-07-15T00:00:00"),
    endDate: new Date("2019-04-30T00:00:00"),
    taskName: "14.04.5 LTS (HWE)",
    taskVersion: "4.4 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2019-04-30T00:00:00"),
    endDate: new Date("2024-05-17T00:00:00"),
    taskName: "14.04.5 LTS (HWE)",
    taskVersion: "4.4 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2024-05-17T00:00:00"),
    endDate: new Date("2029-05-01T00:00:00"),
    taskName: "14.04.5 LTS (HWE)",
    taskVersion: "4.4 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2016-07-21T00:00:00"),
    endDate: new Date("2021-04-30T00:00:00"),
    taskName: "16.04.1 LTS",
    taskVersion: "4.4 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2021-04-30T00:00:00"),
    endDate: new Date("2026-05-21T00:00:00"),
    taskName: "16.04.1 LTS",
    taskVersion: "4.4 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2026-05-21T00:00:00"),
    endDate: new Date("2031-05-01T00:00:00"),
    taskName: "16.04.1 LTS",
    taskVersion: "4.4 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2016-04-21T00:00:00"),
    endDate: new Date("2021-04-21T00:00:00"),
    taskName: "16.04.0 LTS",
    taskVersion: "4.4 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2021-04-21T00:00:00"),
    endDate: new Date("2026-05-21T00:00:00"),
    taskName: "16.04.0 LTS",
    taskVersion: "4.4 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2026-05-21T00:00:00"),
    endDate: new Date("2031-05-01T00:00:00"),
    taskName: "16.04.0 LTS",
    taskVersion: "4.4 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2014-07-24T00:00:00"),
    endDate: new Date("2019-04-30T00:00:00"),
    taskName: "14.04.1 LTS",
    taskVersion: "3.13 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2019-04-30T00:00:00"),
    endDate: new Date("2024-05-17T00:00:00"),
    taskName: "14.04.1 LTS",
    taskVersion: "3.13 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2024-05-17T00:00:00"),
    endDate: new Date("2029-05-01T00:00:00"),
    taskName: "14.04.1 LTS",
    taskVersion: "3.13 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2014-04-17T00:00:00"),
    endDate: new Date("2019-04-17T00:00:00"),
    taskName: "14.04.0 LTS",
    taskVersion: "3.13 kernel",
    status: "LTS",
  },
  {
    startDate: new Date("2019-04-17T00:00:00"),
    endDate: new Date("2024-05-17T00:00:00"),
    taskName: "14.04.0 LTS",
    taskVersion: "3.13 kernel",
    status: "ESM",
  },
  {
    startDate: new Date("2024-05-17T00:00:00"),
    endDate: new Date("2029-05-01T00:00:00"),
    taskName: "14.04.0 LTS",
    taskVersion: "3.13 kernel",
    status: "PRO_LEGACY_SUPPORT",
  },
];

export var kernelReleases2204 = [
  {
    startDate: new Date("2022-04-23T00:00:00"),
    endDate: new Date("2027-04-22T00:00:00"),
    taskName: "Ubuntu 22.04.0 LTS (v5.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2027-04-22T00:00:00"),
    endDate: new Date("2032-04-20T00:00:00"),
    taskName: "Ubuntu 22.04.0 LTS (v5.15)",
    status: "ESM",
  },
  {
    startDate: new Date("2022-08-21T00:00:00"),
    endDate: new Date("2027-04-22T00:00:00"),
    taskName: "Ubuntu 22.04.1 LTS (v5.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2024-02-01T00:00:00"),
    endDate: new Date("2024-08-01T00:00:00"),
    taskName: "Ubuntu 22.04.4 LTS (v6.5)",
    status: "LTS",
  },
];

export var kernelReleases2004 = [
  {
    startDate: new Date("2022-08-11T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04.5 LTS (v5.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2025-04-22T00:00:00"),
    endDate: new Date("2030-04-21T00:00:00"),
    taskName: "Ubuntu 20.04.5 LTS (v5.15)",
    status: "ESM",
  },
  {
    startDate: new Date("2020-08-22T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04.1 LTS (v5.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2025-04-22T00:00:00"),
    endDate: new Date("2030-04-21T00:00:00"),
    taskName: "Ubuntu 20.04.1 LTS (v5.4)",
    status: "ESM",
  },
  {
    startDate: new Date("2020-04-23T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04.0 LTS (v5.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2025-04-22T00:00:00"),
    endDate: new Date("2030-04-21T00:00:00"),
    taskName: "Ubuntu 20.04.0 LTS (v5.4)",
    status: "ESM",
  },
];

export var kernelReleases1804 = [
  {
    startDate: new Date("2020-08-01T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "Ubuntu 18.04.5 LTS (v5.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2023-04-20T00:00:00"),
    endDate: new Date("2028-04-18T00:00:00"),
    taskName: "Ubuntu 18.04.5 LTS (v5.4)",
    status: "ESM",
  },
  {
    startDate: new Date("2018-07-26T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "Ubuntu 18.04.1 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2023-04-20T00:00:00"),
    endDate: new Date("2028-04-18T00:00:00"),
    taskName: "Ubuntu 18.04.1 LTS (v4.15)",
    status: "ESM",
  },
  {
    startDate: new Date("2018-04-26T00:00:00"),
    endDate: new Date("2023-04-25T00:00:00"),
    taskName: "Ubuntu 18.04.0 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2023-04-25T00:00:00"),
    endDate: new Date("2028-04-23T00:00:00"),
    taskName: "Ubuntu 18.04.0 LTS (v4.15)",
    status: "ESM",
  },
];

export var kernelReleases1604 = [
  {
    startDate: new Date("2018-08-21T00:00:00"),
    endDate: new Date("2021-04-20T00:00:00"),
    taskName: "Ubuntu 16.04.5 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2021-04-20T00:00:00"),
    endDate: new Date("2026-04-19T00:00:00"),
    taskName: "Ubuntu 16.04.5 LTS (v4.15)",
    status: "ESM",
  },
  {
    startDate: new Date("2016-08-21T00:00:00"),
    endDate: new Date("2021-04-20T00:00:00"),
    taskName: "Ubuntu 16.04.1 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2021-04-20T00:00:00"),
    endDate: new Date("2026-04-19T00:00:00"),
    taskName: "Ubuntu 16.04.1 LTS (v4.4)",
    status: "ESM",
  },
  {
    startDate: new Date("2016-04-21T00:00:00"),
    endDate: new Date("2021-04-20T00:00:00"),
    taskName: "Ubuntu 16.04.0 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2021-04-20T00:00:00"),
    endDate: new Date("2026-04-19T00:00:00"),
    taskName: "Ubuntu 16.04.0 LTS (v4.4)",
    status: "ESM",
  },
];

export var kernelReleases1404 = [
  {
    startDate: new Date("2016-08-21T00:00:00"),
    endDate: new Date("2019-04-20T00:00:00"),
    taskName: "Ubuntu 14.04.5 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2019-04-20T00:00:00"),
    endDate: new Date("2024-04-19T00:00:00"),
    taskName: "Ubuntu 14.04.5 LTS (v4.4)",
    status: "ESM",
  },
];

export var kernelReleasesALL = [
  {
    startDate: new Date("2016-01-01T00:00:00"),
    endDate: new Date("2016-04-21T00:00:00"),
    taskName: "Ubuntu 16.04.0 LTS (v4.4)",
    status: "EARLY",
  },
  {
    startDate: new Date("2016-04-21T00:00:00"),
    endDate: new Date("2021-04-20T00:00:00"),
    taskName: "Ubuntu 16.04.0 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2016-05-01T00:00:00"),
    endDate: new Date("2016-08-21T00:00:00"),
    taskName: "Ubuntu 16.04.1 LTS (v4.4)",
    status: "EARLY",
  },
  {
    startDate: new Date("2016-08-21T00:00:00"),
    endDate: new Date("2021-04-20T00:00:00"),
    taskName: "Ubuntu 16.04.1 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2016-05-01T00:00:00"),
    endDate: new Date("2016-08-21T00:00:00"),
    taskName: "Ubuntu 14.04.5 LTS (v4.4)",
    status: "EARLY",
  },
  {
    startDate: new Date("2016-08-21T00:00:00"),
    endDate: new Date("2019-04-20T00:00:00"),
    taskName: "Ubuntu 14.04.5 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2018-01-03T00:00:00"),
    endDate: new Date("2018-04-21T00:00:00"),
    taskName: "Ubuntu 18.04.0 LTS (v4.15)",
    status: "EARLY",
  },
  {
    startDate: new Date("2018-04-21T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "Ubuntu 18.04.0 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2018-04-04T00:00:00"),
    endDate: new Date("2018-07-01T00:00:00"),
    taskName: "Ubuntu 18.04.1 LTS (v4.15)",
    status: "EARLY",
  },
  {
    startDate: new Date("2018-07-01T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "Ubuntu 18.04.1 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2018-05-04T00:00:00"),
    endDate: new Date("2018-08-21T00:00:00"),
    taskName: "Ubuntu 16.04.5 LTS (v4.15)",
    status: "EARLY",
  },
  {
    startDate: new Date("2018-08-21T00:00:00"),
    endDate: new Date("2021-04-20T00:00:00"),
    taskName: "Ubuntu 16.04.5 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2020-01-24T00:00:00"),
    endDate: new Date("2020-04-23T00:00:00"),
    taskName: "Ubuntu 20.04.0 LTS (v5.4)",
    status: "EARLY",
  },
  {
    startDate: new Date("2020-04-23T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04.0 LTS (v5.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2020-04-23T00:00:00"),
    endDate: new Date("2020-07-22T00:00:00"),
    taskName: "Ubuntu 20.04.1 LTS (v5.4)",
    status: "EARLY",
  },
  {
    startDate: new Date("2020-07-22T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04.1 LTS (v5.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2020-05-01T00:00:00"),
    endDate: new Date("2020-08-01T00:00:00"),
    taskName: "Ubuntu 18.04.5 LTS (v5.4)",
    status: "EARLY",
  },
  {
    startDate: new Date("2020-08-01T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "Ubuntu 18.04.5 LTS (v5.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2022-01-01T00:00:00"),
    endDate: new Date("2022-04-01T00:00:00"),
    taskName: "Ubuntu 22.04.0 LTS (v5.15)",
    status: "EARLY",
  },
  {
    startDate: new Date("2022-04-01T00:00:00"),
    endDate: new Date("2027-04-01T00:00:00"),
    taskName: "Ubuntu 22.04.0 LTS (v5.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2022-05-13T00:00:00"),
    endDate: new Date("2022-08-11T00:00:00"),
    taskName: "Ubuntu 20.04.5 LTS (v5.15)",
    status: "EARLY",
  },
  {
    startDate: new Date("2022-08-11T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04.5 LTS (v5.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2022-08-01T00:00:00"),
    endDate: new Date("2027-04-01T00:00:00"),
    taskName: "Ubuntu 22.04.1 LTS (v5.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2023-10-01T00:00:00"),
    endDate: new Date("2024-07-01T00:00:00"),
    taskName: "Ubuntu 23.10 (v6.5)",
    status: "INTERIM_RELEASE",
  },
  {
    startDate: new Date("2024-02-01T00:00:00"),
    endDate: new Date("2024-08-01T00:00:00"),
    taskName: "Ubuntu 22.04.4 LTS (v6.5)",
    status: "LTS",
  },
];

export var kernelReleasesLTS = [
  {
    startDate: new Date("2016-04-21T00:00:00"),
    endDate: new Date("2018-04-01T00:00:00"),
    taskName: "Ubuntu 16.04.0 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2018-04-01T00:00:00"),
    endDate: new Date("2023-03-31T00:00:00"),
    taskName: "Ubuntu 16.04.0 LTS (v4.4)",
    status: "CVE",
  },
  {
    startDate: new Date("2016-08-21T00:00:00"),
    endDate: new Date("2018-04-01T00:00:00"),
    taskName: "Ubuntu 14.04.5 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2018-04-01T00:00:00"),
    endDate: new Date("2019-04-20T00:00:00"),
    taskName: "Ubuntu 14.04.5 LTS (v4.4)",
    status: "CVE",
  },
  {
    startDate: new Date("2016-08-21T00:00:00"),
    endDate: new Date("2018-04-01T00:00:00"),
    taskName: "Ubuntu 16.04.1 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2018-04-01T00:00:00"),
    endDate: new Date("2021-04-20T00:00:00"),
    taskName: "Ubuntu 16.04.1 LTS (v4.4)",
    status: "CVE",
  },
  {
    startDate: new Date("2018-04-26T00:00:00"),
    endDate: new Date("2020-04-01T00:00:00"),
    taskName: "Ubuntu 18.04.0 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2020-04-01T00:00:00"),
    endDate: new Date("2025-03-31T00:00:00"),
    taskName: "Ubuntu 18.04.0 LTS (v4.15)",
    status: "CVE",
  },
  {
    startDate: new Date("2018-07-26T00:00:00"),
    endDate: new Date("2020-04-01T00:00:00"),
    taskName: "Ubuntu 18.04.1 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2020-04-01T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "Ubuntu 18.04.1 LTS (v4.15)",
    status: "CVE",
  },
  {
    startDate: new Date("2018-08-21T00:00:00"),
    endDate: new Date("2020-04-01T00:00:00"),
    taskName: "Ubuntu 16.04.5 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2020-04-01T00:00:00"),
    endDate: new Date("2021-04-20T00:00:00"),
    taskName: "Ubuntu 16.04.5 LTS (v4.15)",
    status: "CVE",
  },
  {
    startDate: new Date("2020-04-23T00:00:00"),
    endDate: new Date("2022-04-23T00:00:00"),
    taskName: "Ubuntu 20.04.0 LTS (v5.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2022-04-23T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04.0 LTS (v5.4)",
    status: "CVE",
  },
  {
    startDate: new Date("2020-07-22T00:00:00"),
    endDate: new Date("2022-04-13T00:00:00"),
    taskName: "Ubuntu 20.04.1 LTS (v5.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2022-04-13T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04.1 LTS (v5.4)",
    status: "CVE",
  },
  {
    startDate: new Date("2020-08-01T00:00:00"),
    endDate: new Date("2022-04-23T00:00:00"),
    taskName: "Ubuntu 18.04.5 LTS (v5.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2022-04-23T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "Ubuntu 18.04.5 LTS (v5.4)",
    status: "CVE",
  },
  {
    startDate: new Date("2022-04-01T00:00:00"),
    endDate: new Date("2024-04-01T00:00:00"),
    taskName: "Ubuntu 22.04.0 LTS (v5.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2024-04-01T00:00:00"),
    endDate: new Date("2027-04-01T00:00:00"),
    taskName: "Ubuntu 22.04.0 LTS (v5.15)",
    status: "CVE",
  },
  {
    startDate: new Date("2022-08-11T00:00:00"),
    endDate: new Date("2024-08-10T00:00:00"),
    taskName: "Ubuntu 20.04.5 LTS (v5.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2024-08-10T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04.5 LTS (v5.15)",
    status: "CVE",
  },
  {
    startDate: new Date("2022-08-01T00:00:00"),
    endDate: new Date("2024-04-01T00:00:00"),
    taskName: "Ubuntu 22.04.1 LTS (v5.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2024-04-01T00:00:00"),
    endDate: new Date("2027-04-01T00:00:00"),
    taskName: "Ubuntu 22.04.1 LTS (v5.15)",
    status: "CVE",
  },
  {
    startDate: new Date("2024-02-01T00:00:00"),
    endDate: new Date("2024-08-01T00:00:00"),
    taskName: "Ubuntu 22.04.4 LTS (v6.5)",
    status: "LTS",
  },
];

export var kernelReleaseSchedule = [
  {
    startDate: new Date("2014-04-21T00:00:00"),
    endDate: new Date("2019-04-20T00:00:00"),
    taskName: "Ubuntu 14.04 LTS (v3.13)",
    status: "LTS",
  },
  {
    startDate: new Date("2016-04-21T00:00:00"),
    endDate: new Date("2021-04-20T00:00:00"),
    taskName: "Ubuntu 16.04 LTS (v4.4)",
    status: "LTS",
  },
  {
    startDate: new Date("2018-04-21T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "Ubuntu 18.04 LTS (v4.15)",
    status: "LTS",
  },
  {
    startDate: new Date("2020-04-23T00:00:00"),
    endDate: new Date("2025-04-22T00:00:00"),
    taskName: "Ubuntu 20.04 LTS (v5.4)",
    status: "LTS",
  },
];

export var openStackReleases = [
  {
    startDate: new Date("2024-04-01T00:00:00"),
    endDate: new Date("2032-04-01T00:00:00"),
    taskName: "OpenStack 2024.1",
    status: "MATCHING_OPENSTACK_RELEASE_SUPPORT",
  },
  {
    startDate: new Date("2023-10-01T00:00:00"),
    endDate: new Date("2024-07-01T00:00:00"),
    taskName: "OpenStack 2023.2",
    status: "MATCHING_OPENSTACK_RELEASE_SUPPORT",
  },
  {
    startDate: new Date("2023-04-01T00:00:00"),
    endDate: new Date("2024-10-01T00:00:00"),
    taskName: "OpenStack 2023.1",
    status: "MATCHING_OPENSTACK_RELEASE_SUPPORT",
  },
  {
    startDate: new Date("2024-10-01T00:00:00"),
    endDate: new Date("2026-04-01T00:00:00"),
    taskName: "OpenStack 2023.1",
    status: "EXTENDED_SUPPORT_FOR_CUSTOMERS",
  },
  {
    startDate: new Date("2022-04-01T00:00:00"),
    endDate: new Date("2027-04-01T00:00:00"),
    taskName: "OpenStack Yoga LTS",
    status: "MATCHING_OPENSTACK_RELEASE_SUPPORT",
  },
  {
    startDate: new Date("2027-04-01T00:00:00"),
    endDate: new Date("2032-04-01T00:00:00"),
    taskName: "OpenStack Yoga LTS",
    status: "ESM",
  },
  {
    startDate: new Date("2022-04-01T00:00:00"),
    endDate: new Date("2027-04-01T00:00:00"),
    taskName: "Ubuntu 22.04 LTS",
    status: "LTS",
  },
  {
    startDate: new Date("2027-04-01T00:00:00"),
    endDate: new Date("2032-04-01T00:00:00"),
    taskName: "Ubuntu 22.04 LTS",
    status: "ESM",
  },
  {
    startDate: new Date("2022-04-01T00:00:00"),
    endDate: new Date("2025-04-01T00:00:00"),
    taskName: "OpenStack Yoga",
    status: "MATCHING_OPENSTACK_RELEASE_SUPPORT",
  },
  {
    startDate: new Date("2020-05-15T00:00:00"),
    endDate: new Date("2025-04-01T00:00:00"),
    taskName: "OpenStack Ussuri LTS",
    status: "MATCHING_OPENSTACK_RELEASE_SUPPORT",
  },
  {
    startDate: new Date("2025-04-01T00:00:00"),
    endDate: new Date("2030-04-01T00:00:00"),
    taskName: "OpenStack Ussuri LTS",
    status: "EXTENDED_SUPPORT_MAINTENANCE",
  },
  {
    startDate: new Date("2025-04-01T00:00:00"),
    endDate: new Date("2030-04-01T00:00:00"),
    taskName: "OpenStack Ussuri LTS",
    status: "ESM",
  },
  {
    startDate: new Date("2020-04-01T00:00:00"),
    endDate: new Date("2025-04-01T00:00:00"),
    taskName: "Ubuntu 20.04 LTS",
    status: "LTS",
  },
  {
    startDate: new Date("2025-04-01T00:00:00"),
    endDate: new Date("2030-04-01T00:00:00"),
    taskName: "Ubuntu 20.04 LTS",
    status: "ESM",
  },
  {
    startDate: new Date("2018-04-20T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "OpenStack Queens LTS",
    status: "MATCHING_OPENSTACK_RELEASE_SUPPORT",
  },
  {
    startDate: new Date("2023-04-20T00:00:00"),
    endDate: new Date("2028-04-01T00:00:00"),
    taskName: "OpenStack Queens LTS",
    status: "ESM",
  },
  {
    startDate: new Date("2018-04-20T00:00:00"),
    endDate: new Date("2023-04-20T00:00:00"),
    taskName: "Ubuntu 18.04 LTS",
    status: "LTS",
  },
  {
    startDate: new Date("2023-04-20T00:00:00"),
    endDate: new Date("2028-04-01T00:00:00"),
    taskName: "Ubuntu 18.04 LTS",
    status: "ESM",
  },
];

export var kubernetesReleases = [
  {
    startDate: new Date("2024-04-15T00:00:00"),
    endDate: new Date("2025-04-28T00:00:00"),
    taskName: "Kubernetes 1.30",
    status: "CANONICAL_KUBERNETES_SUPPORT",
  },
  {
    startDate: new Date("2025-04-28T00:00:00"),
    endDate: new Date("2025-12-28T00:00:00"),
    taskName: "Kubernetes 1.30",
    status: "CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2024-08-01T00:00:00"),
    endDate: new Date("2025-08-28T00:00:00"),
    taskName: "Kubernetes 1.31",
    status: "CANONICAL_KUBERNETES_SUPPORT",
  },
  {
    startDate: new Date("2025-08-28T00:00:00"),
    endDate: new Date("2026-04-28T00:00:00"),
    taskName: "Kubernetes 1.31",
    status: "CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2024-12-01T00:00:00"),
    endDate: new Date("2025-12-28T00:00:00"),
    taskName: "Kubernetes 1.32",
    status: "CANONICAL_KUBERNETES_SUPPORT",
  },
  {
    startDate: new Date("2025-12-28T00:00:00"),
    endDate: new Date("2026-08-28T00:00:00"),
    taskName: "Kubernetes 1.32",
    status: "CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2025-04-01T00:00:00"),
    endDate: new Date("2026-04-01T00:00:00"),
    taskName: "Kubernetes 1.33",
    status: "CANONICAL_KUBERNETES_SUPPORT",
  },
  {
    startDate: new Date("2026-04-01T00:00:00"),
    endDate: new Date("2026-12-01T00:00:00"),
    taskName: "Kubernetes 1.33",
    status: "CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2025-08-01T00:00:00"),
    endDate: new Date("2026-08-01T00:00:00"),
    taskName: "Kubernetes 1.34",
    status: "CANONICAL_KUBERNETES_SUPPORT",
  },
  {
    startDate: new Date("2026-08-01T00:00:00"),
    endDate: new Date("2027-04-01T00:00:00"),
    taskName: "Kubernetes 1.34",
    status: "CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE",
  },
];

export var kubernetesReleasesLTS = [
  {
    startDate: new Date("2024-12-01T00:00:00"),
    endDate: new Date("2025-12-01T00:00:00"),
    taskName: "Kubernetes 1.32.x LTS",
    status: "CANONICAL_KUBERNETES_SUPPORT",
  },
  {
    startDate: new Date("2025-12-01T00:00:00"),
    endDate: new Date("2034-12-01T00:00:00"),
    taskName: "Kubernetes 1.32.x LTS",
    status: "CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2034-12-01T00:00:00"),
    endDate: new Date("2039-12-01T00:00:00"),
    taskName: "Kubernetes 1.32.x LTS",
    status: "CANONICAL_KUBERNETES_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2025-06-01T00:00:00"),
    endDate: new Date("2026-06-01T00:00:00"),
    taskName: "Kubernetes 1.33.x",
    status: "CANONICAL_KUBERNETES_SUPPORT",
  },
  {
    startDate: new Date("2026-06-01T00:00:00"),
    endDate: new Date("2027-06-01T00:00:00"),
    taskName: "Kubernetes 1.33.x",
    status: "CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2027-06-01T00:00:00"),
    endDate: new Date("2027-06-01T00:00:00"),
    taskName: "Kubernetes 1.33.x",
    status: "CANONICAL_KUBERNETES_LEGACY_SUPPORT",
  },
  {
    startDate: new Date("2025-09-01T00:00:00"),
    endDate: new Date("2026-09-01T00:00:00"),
    taskName: "Kubernetes 1.34.x",
    status: "CANONICAL_KUBERNETES_SUPPORT",
  },
  {
    startDate: new Date("2026-09-01T00:00:00"),
    endDate: new Date("2027-06-01T00:00:00"),
    taskName: "Kubernetes 1.34.x",
    status: "CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2027-06-01T00:00:00"),
    endDate: new Date("2027-06-01T00:00:00"),
    taskName: "Kubernetes 1.34.x",
    status: "CANONICAL_KUBERNETES_LEGACY_SUPPORT",
  },
];

export var microStackReleases = [
  {
    startDate: new Date("2026-04-01T00:00:00"),
    endDate: new Date("2031-04-01T00:00:00"),
    taskName: "OpenStack 2026.1 LTS",
    status: "STANDARD_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2031-04-01T00:00:00"),
    endDate: new Date("2036-04-01T00:00:00"),
    taskName: "OpenStack 2026.1 LTS",
    status: "MICROSTACK_ESM",
  },
  {
    startDate: new Date("2026-04-01T00:00:00"),
    endDate: new Date("2036-04-01T00:00:00"),
    taskName: "OpenStack 2026.1 LTS",
    status: "PRO_SUPPORT",
  },
  {
    startDate: new Date("2025-10-01T00:00:00"),
    endDate: new Date("2026-07-01T00:00:00"),
    taskName: "OpenStack 2025.2",
    status: "STANDARD_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2025-04-01T00:00:00"),
    endDate: new Date("2026-01-01T00:00:00"),
    taskName: "OpenStack 2025.1",
    status: "STANDARD_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2026-01-01T00:00:00"),
    endDate: new Date("2028-04-01T00:00:00"),
    taskName: "OpenStack 2025.1",
    status: "MICROSTACK_ESM",
  },
  {
    startDate: new Date("2025-04-01T00:00:00"),
    endDate: new Date("2028-04-01T00:00:00"),
    taskName: "OpenStack 2025.1",
    status: "PRO_SUPPORT",
  },
  {
    startDate: new Date("2024-10-01T00:00:00"),
    endDate: new Date("2025-07-01T00:00:00"),
    taskName: "OpenStack 2024.2",
    status: "STANDARD_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2024-04-01T00:00:00"),
    endDate: new Date("2029-04-01T00:00:00"),
    taskName: "OpenStack 2024.1 LTS",
    status: "STANDARD_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2029-04-01T00:00:00"),
    endDate: new Date("2034-04-01T00:00:00"),
    taskName: "OpenStack 2024.1 LTS",
    status: "MICROSTACK_ESM",
  },
  {
    startDate: new Date("2024-04-01T00:00:00"),
    endDate: new Date("2034-04-01T00:00:00"),
    taskName: "OpenStack 2024.1 LTS",
    status: "PRO_SUPPORT",
  },
  {
    startDate: new Date("2023-10-01T00:00:00"),
    endDate: new Date("2024-07-01T00:00:00"),
    taskName: "OpenStack 2023.2",
    status: "STANDARD_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2023-06-01T00:00:00"),
    endDate: new Date("2024-01-01T00:00:00"),
    taskName: "OpenStack 2023.1",
    status: "STANDARD_SECURITY_MAINTENANCE",
  },
  {
    startDate: new Date("2024-01-01T00:00:00"),
    endDate: new Date("2026-04-01T00:00:00"),
    taskName: "OpenStack 2023.1",
    status: "MICROSTACK_ESM",
  },
  {
    startDate: new Date("2023-06-01T00:00:00"),
    endDate: new Date("2026-04-01T00:00:00"),
    taskName: "OpenStack 2023.1",
    status: "PRO_SUPPORT",
  },
];

export var desktopServerStatus = {
  HARDWARE_AND_MAINTENANCE_UPDATES: "chart__bar--orange",
  MAINTENANCE_UPDATES: "chart__bar--orange-light",
  ESM: "chart__bar--aubergine-light",
  MAIN_UNIVERSE: "chart__bar--aubergine-mid-light",
  INTERIM_RELEASE: "chart__bar--grey",
  PRO_LEGACY_SUPPORT: "chart__bar--black",
};

export var kernelStatus = {
  LTS: "chart__bar--orange",
  ESM: "chart__bar--aubergine-light",
  INTERIM_RELEASE: "chart__bar--grey",
  PRO_LEGACY_SUPPORT: "chart__bar--black",
};

export var kernelReleaseScheduleStatus = {
  LTS: "chart__bar--black",
  INTERIM_RELEASE: "chart__bar--grey",
};

export var kernelStatusLTS = {
  LTS: "chart__bar--black",
  CVE: "chart__bar--grey",
};

export var kernelStatusALL = {
  LTS: "chart__bar--black",
  INTERIM_RELEASE: "chart__bar--grey",
  EARLY: "chart__bar--aubergine-light",
};

export var openStackStatus = {
  LTS: "chart__bar--black",
  MATCHING_OPENSTACK_RELEASE_SUPPORT: "chart__bar--mid-dark",
  ESM: "chart__bar--aubergine",
  EXTENDED_SUPPORT_FOR_CUSTOMERS: "chart__bar--aubergine-light",
};

export var kubernetesStatus = {
  CANONICAL_KUBERNETES_SUPPORT: "chart__bar--black",
  CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE: "chart__bar--aubergine",
};

export var kubernetesStatusLTS = {
  CANONICAL_KUBERNETES_SUPPORT: "chart__bar--black",
  CANONICAL_KUBERNETES_EXPANDED_SECURITY_MAINTENANCE: "chart__bar--aubergine",
  CANONICAL_KUBERNETES_LEGACY_SUPPORT: "chart__bar--orange",
};

export var microStackStatus = {
  STANDARD_SECURITY_MAINTENANCE: "chart__bar--orange",
  MICROSTACK_ESM: "chart__bar--aubergine",
  PRO_SUPPORT: "chart_bar--charcoal",
};

export var desktopServerReleaseNames = [
  "26.10 (Stonking Stingray)",
  "26.04 LTS (Resolute Raccoon)",
  "24.04 LTS (Noble Numbat)",
  "22.04 LTS (Jammy Jellyfish)",
  "20.04 LTS (Focal Fossa)",
  "18.04 LTS (Bionic Beaver)",
  "16.04 LTS (Xenial Xerus)",
  "14.04 LTS (Trusty Tahr)",
];

export var kernelReleaseNames = [
  "26.10",
  "24.04.5 LTS (HWE)",
  "26.04.0 LTS",
  "24.04.4 LTS (HWE)",
  "25.10",
  "22.04.5 LTS (HWE)",
  "24.04.1 LTS",
  "24.04.0 LTS",
  "20.04.5 LTS (HWE)",
  "22.04.1 LTS",
  "22.04.0 LTS",
  "18.04.5 LTS (HWE)",
  "20.04.1 LTS",
  "20.04.0 LTS",
  "16.04.5 LTS (HWE)",
  "18.04.1 LTS",
  "18.04.0 LTS",
  "14.04.5 LTS (HWE)",
  "16.04.1 LTS",
  "16.04.0 LTS",
  "14.04.1 LTS",
  "14.04.0 LTS",
];

// Index-parallel to kernelReleaseNames; blank repeats the version of the row above.
export var kernelVersionNames = [
  "7.3",
  "7.0",
  "",
  "6.17",
  "",
  "6.8",
  "",
  "",
  "5.15",
  "",
  "",
  "5.4",
  "",
  "",
  "4.15",
  "",
  "",
  "4.4",
  "",
  "",
  "3.13",
  "",
];

export var kernelReleaseNames2204 = [
  "Ubuntu 22.04.0 LTS (v5.15)",
  "Ubuntu 22.04.1 LTS (v5.15)",
  "Ubuntu 22.04.4 LTS (v6.5)",
];

export var kernelReleaseNames2004 = [
  "Ubuntu 20.04.0 LTS (v5.4)",
  "Ubuntu 20.04.1 LTS (v5.4)",
  "Ubuntu 20.04.5 LTS (v5.15)",
];

export var kernelReleaseNames1804 = [
  "Ubuntu 18.04.0 LTS (v4.15)",
  "Ubuntu 18.04.1 LTS (v4.15)",
  "Ubuntu 18.04.5 LTS (v5.4)",
];

export var kernelReleaseNames1604 = [
  "Ubuntu 16.04.0 LTS (v4.4)",
  "Ubuntu 16.04.1 LTS (v4.4)",
  "Ubuntu 16.04.5 LTS (v4.15)",
];

export var kernelReleaseNames1404 = ["Ubuntu 14.04.5 LTS (v4.4)"];

export var kernelReleaseNamesALL = [
  "Ubuntu 16.04.0 LTS (v4.4)",
  "Ubuntu 16.04.1 LTS (v4.4)",
  "Ubuntu 14.04.5 LTS (v4.4)",
  "Ubuntu 18.04.0 LTS (v4.15)",
  "Ubuntu 18.04.1 LTS (v4.15)",
  "Ubuntu 16.04.5 LTS (v4.15)",
  "Ubuntu 20.04.0 LTS (v5.4)",
  "Ubuntu 20.04.1 LTS (v5.4)",
  "Ubuntu 18.04.5 LTS (v5.4)",
  "Ubuntu 22.04.0 LTS (v5.15)",
  "Ubuntu 22.04.1 LTS (v5.15)",
  "Ubuntu 20.04.5 LTS (v5.15)",
  "Ubuntu 23.10 (v6.5)",
  "Ubuntu 22.04.4 LTS (v6.5)",
];

export var kernelReleaseNamesLTS = [
  "Ubuntu 16.04.0 LTS (v4.4)",
  "Ubuntu 16.04.1 LTS (v4.4)",
  "Ubuntu 14.04.5 LTS (v4.4)",
  "Ubuntu 18.04.0 LTS (v4.15)",
  "Ubuntu 18.04.1 LTS (v4.15)",
  "Ubuntu 16.04.5 LTS (v4.15)",
  "Ubuntu 20.04.0 LTS (v5.4)",
  "Ubuntu 20.04.1 LTS (v5.4)",
  "Ubuntu 18.04.5 LTS (v5.4)",
  "Ubuntu 22.04.0 LTS (v5.15)",
  "Ubuntu 22.04.1 LTS (v5.15)",
  "Ubuntu 20.04.5 LTS (v5.15)",
  "Ubuntu 22.04.4 LTS (v6.5)",
];

export var openStackReleaseNames = [
  "OpenStack 2024.1",
  "OpenStack 2023.2",
  "OpenStack 2023.1",
  "OpenStack Yoga LTS",
  "Ubuntu 22.04 LTS",
  "OpenStack Yoga",
  "OpenStack Ussuri LTS",
  "Ubuntu 20.04 LTS",
  "OpenStack Queens LTS",
  "Ubuntu 18.04 LTS",
];

export var microStackReleaseNames = [
  "OpenStack 2026.1 LTS",
  "OpenStack 2025.2",
  "OpenStack 2025.1",
  "OpenStack 2024.2",
  "OpenStack 2024.1 LTS",
  "OpenStack 2023.2",
  "OpenStack 2023.1",
];

export var kubernetesReleaseNames = [
  "Kubernetes 1.34",
  "Kubernetes 1.33",
  "Kubernetes 1.32",
  "Kubernetes 1.31",
  "Kubernetes 1.30",
];

export var kubernetesReleaseNamesLTS = [
  "Kubernetes 1.34.x",
  "Kubernetes 1.33.x",
  "Kubernetes 1.32.x LTS",
];

export var kernelReleaseScheduleNames = [
  "Ubuntu 14.04 LTS (v3.13)",
  "Ubuntu 16.04 LTS (v4.4)",
  "Ubuntu 18.04 LTS (v4.15)",
  "Ubuntu 20.04 LTS (v5.4)",
];
